import React from 'react';

import type { TFaceCardSize } from './base-face-card/BaseFaceCard';
import type { LargeFaceCardProps } from './large-face-card/LargeFaceCard';
import { LargeFaceCard } from './large-face-card/LargeFaceCard';
import type { SmallFaceCardProps } from './small-face-card/SmallFaceCard';
import { SmallFaceCard } from './small-face-card/SmallFaceCard';

export type FaceCardProps = { size?: TFaceCardSize } & (
  { size: 'large' } & LargeFaceCardProps
| { size: 'small' } & SmallFaceCardProps
);

export function FaceCard({
  size = 'large',
  ...props
}: FaceCardProps): React.JSX.Element {
  return (
    <React.Fragment>
      {size === 'large' && <LargeFaceCard {...props as LargeFaceCardProps} />}
      {size === 'small' && <SmallFaceCard {...props as SmallFaceCardProps} />}
    </React.Fragment>
  );
}
